export const updateTypes = {
  ALGORITHM: "Algorithm",
  TOPIC_LITERATURE_REVIEW: "Topic Literature Review",
};
